<template>
  <label class="hp" for="uuidInput">
    <input
      type="text"
      v-model="value"
      autocomplete="off"
      tabindex="-1"
      id="uuidInput"
      placeholder="uuid"
    />
    {{ this.fieldValue }}
  </label>
</template>

<script>
// Fake field CAPTCHA to prevent some bots
export default {
  props: {
    fieldValue: {
      default: "",
    },
  },
  emits: ["update:fieldValue"],
  computed: {
    value: {
      get() {
        return this.fieldValue;
      },
      set(value) {
        this.$emit("update:fieldValue", value);
      },
    },
  },
  methods: {
    validate() {
      if (this.value) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style lang="scss">
.hp {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  width: 0;
  height: 0;
  opacity: 0;
}
</style>
